import { MapLeaflet } from './map_leaflet.js';
import { MarkerLeaflet } from './marker_leaflet.js';
import { LeafletPolyline } from './polyline_leaflet.js';
import { LeafletPopup } from './popup_leaflet.js';

export const APILeaflet = {
  Map: MapLeaflet,
  MapPolyline: LeafletPolyline,
  MapPopup: LeafletPopup,
  Marker: MarkerLeaflet,
};
